import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogProps,
    DialogTitle,
    FormControl,
    InputLabel,
    MenuItem,
    Select,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { EntityTextField } from 'app/components';
import { createEmptyStoreAttribute, StoreAttributes } from 'app/model';
import { ModelWithoutId } from 'app/type';
import {
    prepareAttributes,
    selectPossibleAttributes,
    prepareStoreAttributes,
    selectPossibleStoreAttributes,
} from 'features/cris/cris.slice';

interface AttributeDialogProps extends DialogProps {
    onAddAttribute: (attr: ModelWithoutId<StoreAttributes>) => void;
    onClose: Required<DialogProps>['onClose'];
    type: 'brand' | 'store';
}

export const AttributeDialog: React.FunctionComponent<AttributeDialogProps> = (props) => {
    const { onAddAttribute, type, ...rest } = props;

    const [entity, setEntity] = useState(createEmptyStoreAttribute());
    const dispatch = useDispatch();

    const handleEntityChange = (evt: unknown, name: keyof StoreAttributes, value: unknown): void => {
        setEntity({ ...entity, [name]: value });
    };

    useEffect(() => {
        if ('store' === type) {
            dispatch(prepareStoreAttributes());
        } else {
            dispatch(prepareAttributes());
        }
    }, [type, dispatch]);

    const possibleAttributes = useSelector(
        'store' === type ? selectPossibleStoreAttributes : selectPossibleAttributes,
    ) ?? ['Loading...'];

    return (
        <Dialog {...rest}>
            <DialogTitle id='attribute-dialog-title'>Add Attribute</DialogTitle>
            <DialogContent>
                <FormControl fullWidth>
                    <InputLabel id='attr-name-label'>Name</InputLabel>
                    <Select
                        name='name'
                        labelId='attr-name-label'
                        label='Name'
                        value={entity.name}
                        onChange={(evt) => setEntity({ ...entity, name: evt.target.value })}
                    >
                        {possibleAttributes.map((attr) => (
                            <MenuItem key={attr} value={attr}>
                                {attr === 'MIDMATCH_RELEASE_READY' ? 'RELEASE_READY' : attr}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
                <EntityTextField
                    fullWidth
                    label='Value'
                    name='value'
                    type='number'
                    value={entity}
                    onChange={handleEntityChange}
                />
                <EntityTextField fullWidth label='Detail' name='details' value={entity} onChange={handleEntityChange} />
            </DialogContent>
            <DialogActions>
                <Button color='secondary' onClick={(evt) => rest.onClose(evt, 'backdropClick')}>
                    Cancel
                </Button>
                <Button color='primary' onClick={() => onAddAttribute(entity)}>
                    Save
                </Button>
            </DialogActions>
        </Dialog>
    );
};
